export const IMAGE_ACCEPTABLE_FORMAT_REGEX = /image\/(png|jpg|jpeg|svg)/i;
export const DOCUMENT_ACCEPTABLE_FORMAT_REGEX = /application\/(pdf)|image\/(png|jpg|jpeg|svg)/i;
export const VIDEO_ACCEPTABLE_FORMAT_REGEX =  /(application\/pdf|video\/mp4)/i;
